import { Component, Inject, OnInit } from '@angular/core';
import { DividerModule } from 'primeng/divider';
import { IndustriesService } from '../../../core/services/enum/industries.service';
import { RegionsService } from '../../../core/services/enum/regions.service';
import { SegmentsService } from '../../../core/services/enum/segments.service';
import { TransportServicesService } from '../../../core/services/enum/transportServices.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { L10N_LOCALE, L10nLocale, L10nTranslationModule } from 'angular-l10n';
import { RegionsModel } from '../../../core/models/countries/regions.model';
import { TransportSegmentsModel } from '../../../core/models/transportSegment/transportSegments.model';
import { MultiSelectModule } from 'primeng/multiselect';
import {
  GetEmptySupplierSelectionForm,
  SupplierSelectionFormModel,
} from '../../../core/models/supplierDB/supplierSelectionForm.model';
import { AppConstants } from '../../../app.constants';
import { Subscription } from 'rxjs';

@Component({
  selector: 'supplierDB-registration-registration-selection',
  standalone: true,
  imports: [
    MultiSelectModule,
    DividerModule,
    L10nTranslationModule,
    ReactiveFormsModule,
  ],
  providers: [
    IndustriesService,
    RegionsService,
    SegmentsService,
    TransportServicesService,
  ],
  templateUrl: './registration-selection.component.html',
  styleUrl: './registration-selection.component.scss',
})
export class RegistrationSelectionComponent implements OnInit {
  // selection data
  public services: string[] = [];
  public industries: string[] = [];
  public segments!: TransportSegmentsModel;
  public regions!: RegionsModel;

  // form data
  public selectionForm!: FormGroup;

  private _valueChangeSubscription!: Subscription;

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private _formBuilder: FormBuilder,
    private _industriesService: IndustriesService,
    private _regionsService: RegionsService,
    private _segmentsService: SegmentsService,
    private _transportServicesService: TransportServicesService
  ) {
    this._initSelectionData();
    this._initFormControls();
  }

  ngOnInit() {
    var supplierSelectionData = localStorage.getItem(
      AppConstants.SDB_SUPPLIER_LOCAL_STORAGE_SELECTION
    );
    if (supplierSelectionData !== null) {
      this.selectionForm.patchValue(new SupplierSelectionFormModel(JSON.parse(supplierSelectionData)));
    } else {
      localStorage.setItem(
        AppConstants.SDB_SUPPLIER_LOCAL_STORAGE_SELECTION,
        JSON.stringify(GetEmptySupplierSelectionForm())
      );
    }

    this._valueChangeSubscription = this.selectionForm.valueChanges.subscribe(
      (values: SupplierSelectionFormModel) => {
        localStorage.setItem(
          AppConstants.SDB_SUPPLIER_LOCAL_STORAGE_SELECTION,
          JSON.stringify(values)
        );
      }
    );
  }

  ngOnDestroy(): void {
    this._valueChangeSubscription.unsubscribe();
  }

  private _initFormControls(): void {
    this.selectionForm = this._formBuilder.group({
      services: [[]],
      industries: [[]],
      segmentsSea: [[]],
      segmentsRoad: [[]],
      segmentsAir: [[]],
      segmentsRail: [[]],
      regionsEurope: [[]],
      regionsNorthAmerica: [[]],
      regionsSouthAmerica: [[]],
      regionsAfrica: [[]],
      regionsAsia: [[]],
      regionsAustraliaPacific: [[]],
    });
  }

  private _initSelectionData(): void {
    this.industries = this._industriesService.getIndustriesList();
    this.services = this._transportServicesService.getServicesList();
    this.segments = this._segmentsService.getSegmentsList();

    this.regions = this._regionsService.getRegionsList();
  }

  /**
   * Check if at least one region is selected
   * @returns {boolean} true if at least one region is selected
   */
  public hasOneRegionSelection(): boolean {
    let count = this.selectionForm.value?.regionsNorthAmerica?.length ?? 0;
    count += this.selectionForm.value?.regionsEurope?.length ?? 0;
    count += this.selectionForm.value?.regionsSouthAmerica?.length ?? 0;
    count += this.selectionForm.value?.regionsAfrica?.length ?? 0;
    count += this.selectionForm.value?.regionsAsia?.length ?? 0;
    count += this.selectionForm.value?.regionsAustraliaPacific?.length ?? 0;
    return count >= 1;
  }

  /**
   * Check if at least one segment is selected
   * @returns {boolean} true if at least one segment is selected
   */
  public hasOneSegmentSelection(): boolean {
    let count = this.selectionForm.value?.segmentsSea?.length ?? 0;
    count += this.selectionForm.value?.segmentsRoad?.length ?? 0;
    count += this.selectionForm.value?.segmentsAir?.length ?? 0;
    count += this.selectionForm.value?.segmentsRail?.length ?? 0;
    return count >= 1;
  }
}
